import { render, staticRenderFns } from "./HomeEdgn.vue?vue&type=template&id=a0fb726e&scoped=true&"
import script from "./HomeEdgn.vue?vue&type=script&lang=js&"
export * from "./HomeEdgn.vue?vue&type=script&lang=js&"
import style0 from "./HomeEdgn.vue?vue&type=style&index=0&id=a0fb726e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fb726e",
  null
  
)

export default component.exports